export default {
  modelName: 'feedback',
  label: '一般法律諮詢',
  fields: {
    user: {
      label: '提交人',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'user',
      rules: 'required',
      width: '100px',
    },
    factory: {
      label: '工廠',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'factory',
      rules: 'required',
      width: '100px',
    },
    organization: {
      type: 'belongsTo',
      label: '集團',
      textKey: 'name',
      modelName: 'organization',
    },
    contact_person: {
      type: 'text',
      label: '聯絡人姓名',
      maxlength: 10,
    },
    contact_way: {
      type: 'text',
      label: '聯絡方式',
      maxlength: 10,
    },
    contact_for: {
      type: 'select',
      label: '詢問主旨',
      items: [
        {
          text: '緊急法律協助',
          value: 'urgent_legal_issue',
        },
        {
          text: '系統操作協助',
          value: 'system_operation',
        },
      ],
    },
    tel: {
      type: 'text',
      label: '聯絡電話',
      maxlength: 20,
    },
    email: {
      type: 'email',
      label: '聯絡信箱',
      maxlength: 50,
    },
    //@@@
    type: {
      type: 'select',
      label: '類別',
      defaultValue: 0,
      items: [
        {
          text: '選項一',
          value: 0,
        },
        {
          text: '選項二',
          value: 1,
        },
        {
          text: '其他',
          value: 2,
        },
      ],
    },
    //@@@
    subject: {
      type: 'text',
      label: '主旨',
      maxlength: 500,
    },
    remark: {
      type: 'textarea',
      label: '簡述',
      maxlength: 500,
    },
    files: {
      parentKey: 'factory',
      requiredField: 'factory',
      type: 'files',
      label: '簡述附件',
      uploadUrl: '/sos_request/file/',
    },
    assignee: {
      label: '指派人員',
      type: 'belongsTo',
      textKey: 'name',
      rules: 'required',
      modelName: 'admin',
      orderBy: 'no_number',
      orderWay: 'asc',
      noReset: true,
      sm: 6,
    },
    status: {
      type: 'select',
      label: '處理狀態',
      defaultValue: '0',
      rules: 'required',
      items: [
        {
          text: '尚未處理',
          value: 0,
        },
        {
          text: '處理中',
          value: 1,
        },
        {
          text: '處理完畢',
          value: 2,
        },
      ],
    },
    status_remark: {
      type: 'textarea',
      label: '處理備註',
      maxlength: 500,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    created_at: {
      type: 'datetime',
      label: '提交時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
    user_payload_name: {
      type: 'custom',
      label: '提交人',
      getValue(data) {
        return data.user_payload.name;
      },
    },
  },
};
